import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { execSeatableSql } from './seatable.js';

function WhatWeDo(props) {
    const [capabilityData, setCapabilityData] = useState(null);
    const [industryData, setIndustryData] = useState(null);
    // const [error, setError] = useState(null);

    useEffect(() => {
      async function fetchData() {
        setCapabilityData(null);
        try {
          const rows = await execSeatableSql("SELECT `_id`,`Desc`,`ShortDesc` FROM Subpages WHERE `CapabilityType` = 'Capability' AND `IsActive` IS TRUE AND `IsPublish` IS TRUE ORDER BY `Rank Order`");
          setCapabilityData(rows);
        } catch (err) {
          // setError(err);
        }
        setIndustryData(null);
        try {
          const rows = await execSeatableSql("SELECT `_id`,`Desc`,`ShortDesc` FROM Subpages WHERE `CapabilityType` = 'Industry' AND `IsActive` IS TRUE AND `IsPublish` IS TRUE ORDER BY `Rank Order`");
          setIndustryData(rows);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, []);
  
    return (
      <div className="m-0 p-0">
          <div className="p-2 p-md-5 fs-1 fs-md-2 lato-bold text-accent">{props.type} </div>
          <div className="px-2 px-md-5 d-flex flex-lg-row flex-column">
              {(props.type==="Capabilities") ? (
              <div className="p-2">
                  <div className="mt-3 nav-list">
                  {capabilityData && capabilityData.results.map((row, index) => {return (
                    <Link key={index} className="my-1 nav-link" to={`/capabilities/${row.ShortDesc}#top`}><span>{row.Desc}</span></Link>
                  )})}
                  </div>
              </div>
              ) : (props.type==="Industries") ? (
              <div className="p-2">
                  <div className="mt-3 nav-list">
                  {industryData && industryData.results.map((row, index) => {return (
                      <Link key={index} className="my-1 nav-link" to={`/capabilities/${row.ShortDesc}#top`}><span>{row.Desc}</span></Link>
                  )})}
                  </div>
              </div>
              ) : ''}
          </div>
      </div>
    )
}

export default WhatWeDo;